/*
 * BBC - Rap Map - Header
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';

import logo from './assets/Logo.png';
import noisyBackground from './assets/noise-artboard.svg';
import noisyBackground3 from './assets/BackgroundRepeat_RM-V1.png';

const Header = ({ season, setSeason, setSelectedIndex }) => (
    <header className="Header" style={{ backgroundImage: `url('${season === 3 ? noisyBackground3 : noisyBackground}')` }}>
        <img src={logo} alt="The Rap Map UK" className="Header__Logo" />
        <h1>Check out the uk rap scene and put your name on the map</h1>

        <h2 className="vh">Upload your rap</h2>
        <a
            className="Upload"
            href="https://www.bbc.co.uk/send/u82820424"
            target="_blank"
            rel="noopener noreferrer"
        >
            Upload your rap
        </a>
        <button
            className="Upload"
            onClick={() => {
                const clearSelectedState = async () => {
                    try {
                        setSelectedIndex(null);
                        window.history.pushState(
                            null,
                            null,
                            `${window.location.origin}${window.location.pathname}`
                        );
                    } catch (err) {
                        console.log('error: ', err);
                    }
                }

                clearSelectedState()
                    .then(() => {
                        if (season === 3) {
                            setSeason(2);
                        } else {
                            setSeason(3);
                        }
                    });
            }}
        >
            {season === 3 ? '2020' : '2021'} entries
        </button>
    </header>
);

export default Header;
